import {type PropsWithChildren, createContext, use, useMemo} from 'react'

export type LoadingContextType = boolean
export const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

export function LoadingProvider({children, isLoading}: PropsWithChildren<{isLoading?: boolean}>) {
  const value = useMemo(() => isLoading ?? false, [isLoading])
  return <LoadingContext value={value}>{children}</LoadingContext>
}

export function useLoading(): LoadingContextType {
  const context = use(LoadingContext)
  if (typeof context === 'undefined') {
    throw new Error('useLoading must be used within a LoadingProvider')
  }
  return context
}
